import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import StylerHOC from './Theme/theme-provider-hoc';
import './utils/localization/i18n';
import { GoldspotAuthConfig, AuthenticatorHOC } from 'gsf-util-react-auth';
import { endpoints } from './app-endpoints';

// initialize aws amplify config; pass array of endpoints if needed
GoldspotAuthConfig(endpoints);

const AuthenticatedApp = AuthenticatorHOC(App);
const StyledAndAuthenticatedApp = StylerHOC(AuthenticatedApp);

ReactDOM.render(
  <React.StrictMode>
    <StyledAndAuthenticatedApp />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
